import './AdminDashboardView.scss';

import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { AdminDashboardNavigation } from './AdminDashboardNavigation';
import { AdminDashboardTabs } from './AdminDashboardTabs';
import React from 'react';

export const AdminDashboardView: React.FC = () =>
	<div className='admin-dashboard'>
		<div className='admin-header'>
			<div className='h1'>{ ADMIN_DASHBOARD_COPY.AROVY_ADMIN_PANEL }</div>
			<AdminDashboardNavigation />
		</div>
		<div className='admin-content'>
			<AdminDashboardTabs
				id='admin-tabs' />
		</div>
	</div>;
